var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixedAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 18c.551 0 1 .449 1 1a1 1 0 1 0 2 0 2.996 2.996 0 0 0-2-2.816V16a1 1 0 0 0-2 0v.184A2.996 2.996 0 0 0 13 19c0 1.654 1.346 3 3 3 .551 0 1 .449 1 1s-.449 1-1 1-1-.449-1-1a1 1 0 0 0-2 0c0 1.302.839 2.402 2 2.816V26a1 1 0 0 0 2 0v-.184A2.996 2.996 0 0 0 19 23c0-1.654-1.346-3-3-3-.551 0-1-.449-1-1s.449-1 1-1z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.707 26.293-2-2a.999.999 0 1 0-1.414 1.414l.293.293h-3.108A8.947 8.947 0 0 0 25 21v-5.969A3.034 3.034 0 0 0 21.969 12H21V7c0-2.757-2.243-5-5-5s-5 2.243-5 5v5h-.969A3.035 3.035 0 0 0 7 15.031V21c0 1.849.562 3.569 1.522 5H5.414l.293-.293a.999.999 0 1 0-1.414-1.414l-2 2a.999.999 0 0 0 0 1.414l2 2a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L5.414 28h4.942A8.955 8.955 0 0 0 16 30a8.953 8.953 0 0 0 5.644-2h4.942l-.293.293a.999.999 0 1 0 1.414 1.414l2-2a.999.999 0 0 0 0-1.414zM13 7c0-1.654 1.346-3 3-3s3 1.346 3 3v5h-6zM9 21v-5.969C9 14.462 9.462 14 10.031 14h11.938c.568 0 1.031.462 1.031 1.031V21c0 3.86-3.141 7-7 7-3.86 0-7-3.14-7-7z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedAsset);
export default __webpack_public_path__ + "static/media/fixed-asset.cae3696128a7dedd636ffe14f967542e.svg";
export { ForwardRef as ReactComponent };